import type { Catalogue, Song, SongState } from '@astrasonora/annotation-schema'
import { spanKeys } from '@astrasonora/harmony-engine'
import { clearedSpanKeys } from './attempt.ts'
import { next } from './progression.ts'
import type { PlayerState } from './state.ts'

/**
 * How far a song is charted (spec §7): its span keys, the ones the player has cleared, and their
 * indices. A charted song is asked in full again, so its cleared spans are none.
 */
export function spanProgress(
  song: Song,
  state: SongState | undefined,
): { keys: string[]; cleared: string[]; clearedIndices: number[] } {
  const keys = spanKeys(song.chords)
  if (state?.status === 'charted') return { keys, cleared: [], clearedIndices: [] }
  const cleared = clearedSpanKeys(state, keys)
  const have = new Set(cleared)
  const clearedIndices = keys.map((k, i) => (have.has(k) ? i : -1)).filter((i) => i >= 0)
  return { keys, cleared, clearedIndices }
}

/** May this song be charted now? The night's featured constellation, or one already charted. */
export function runnable(song: Song, state: PlayerState, cat: Catalogue): boolean {
  if (song.demo) return false
  if (state.songs[song.id]?.status === 'charted') return true
  return next(state, cat, song.observatory, song.level) === song.id
}

/** May this song be heard annotated? The night's demo songs and the player's charted ones (concept §6). */
export function heardAnnotated(song: Song, state: SongState | undefined): boolean {
  return song.demo || state?.status === 'charted'
}
